export default __webpack_public_path__ + "static/heroMob1-794bcf3199ef0ca297c987957fea062b.svg";